



















import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Types
import { IProduct } from "@/models/products";
import { IProductProviderData } from "@/models/providers/products";

@Component({
  components: {
    "cross-selling-products": () =>
      import(
        "@/components/app/admin/catalogue/products/relatedProducts/crossSellingProducts.vue"
      )
  }
})
export default class EditRelatedProducts extends Vue {
  public $refs!: {
    crossSellingProducts: HTMLFormElement;
  };

  // Inject
  @Inject({ from: "productProviderData" })
  public readonly $productProviderData!: () => IProductProviderData;

  public get isStaged() {
    return this.$productProviderData().isStaged;
  }

  @Prop({ required: true })
  public productId!: IProduct["id"];
}
